(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["compatibility-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ut-compatibility-tabs')) {
    customElements.define('ut-compatibility-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.tabs = Array.from(this.querySelectorAll('[data-utc-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-utc-panel]'));
        this.activate = (id, focus = false) => {
          this.tabs.forEach(tab => {
            const active = tab.dataset.utcTab === id;
            tab.setAttribute('aria-selected', String(active));
            tab.tabIndex = active ? 0 : -1;
            if (active && focus) {
              tab.focus({ preventScroll: true });
              tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
            }
          });
          this.panels.forEach(panel => { panel.hidden = panel.dataset.utcPanel !== id; });
          requestAnimationFrame(() => this.updateArrows());
        };
        this.updateArrows = () => this.panels.forEach(panel => {
          if (panel.hidden) return;
          const list = panel.querySelector('.utc__list');
          const end = list.scrollWidth - list.clientWidth;
          panel.querySelector('[data-utc-prev]').disabled = list.scrollLeft <= 2;
          panel.querySelector('[data-utc-next]').disabled = list.scrollLeft >= end - 2;
        });
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activate(tab.dataset.utcTab), options);
          tab.addEventListener('keydown', event => {
            let next = index;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else return;
            event.preventDefault();
            this.activate(this.tabs[next].dataset.utcTab, true);
          }, options);
        });
        this.panels.forEach(panel => {
          const list = panel.querySelector('.utc__list');
          const move = direction => list.scrollBy({ left: direction * Math.max(180, list.clientWidth * .85), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          panel.querySelector('[data-utc-prev]').addEventListener('click', () => move(-1), options);
          panel.querySelector('[data-utc-next]').addEventListener('click', () => move(1), options);
          list.addEventListener('scroll', this.updateArrows, { ...options, passive: true });
        });
        this.resizeObserver = new ResizeObserver(this.updateArrows);
        this.resizeObserver.observe(this);
        document.addEventListener('shopify:block:select', event => {
          if (this.contains(event.target) && event.detail?.blockId) this.activate(event.detail.blockId);
        }, options);
        this.updateArrows();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
